import isEqual from "lodash/isEqual";

import { MasterRuleStatus } from "constants/rules";

export const SynchronisedRuleFields = [
  "content",
  "criteria",
  "input_field",
  "quantity_raw_format",
  "unit_amount_raw_format",
  "apply_criteria_filter_to_splits",
  "apply_splits",
];

export const SynchronisedRuleSetFields = ["criteria", "input_field"];

export const isManagedRuleSetOutOfSync = (
  managedRuleSet: RuleSet,
  masterRuleSet: MasterRuleSet,
): boolean =>
  SynchronisedRuleSetFields.some(
    field => !isEqual(managedRuleSet[field], masterRuleSet[field]),
  ) || managedRuleSet.master_rule_set_id !== masterRuleSet.id;

export const isManagedRuleOutOfSync = (
  managedRule: Rule,
  masterRule: MasterRule,
  managedRuleSet: RuleSet,
  masterRuleSet: MasterRuleSet,
): boolean =>
  SynchronisedRuleFields.some(
    field => !isEqual(managedRule[field], masterRule[field]),
  ) ||
  (managedRuleSet &&
    masterRuleSet &&
    isManagedRuleSetOutOfSync(managedRuleSet, masterRuleSet));

export const getMasterRuleStatus = (
  rule: Rule,
  masterRule: MasterRule,
  ruleSet: RuleSet,
  masterRuleSet: MasterRuleSet,
): string => {
  if (!masterRule) {
    return MasterRuleStatus.NOT_MANAGED;
  }
  if (masterRule.soft_deleted_on) {
    return MasterRuleStatus.DELETED;
  }
  if (isManagedRuleOutOfSync(rule, masterRule, ruleSet, masterRuleSet)) {
    return MasterRuleStatus.OUT_SYNC;
  }
  return MasterRuleStatus.IN_SYNC;
};

export const getGSTStatusFromRule = (rule: Rule): string => {
  const fee = rule.fees?.find(ruleFee => ruleFee.name === "GST");
  if (fee) {
    if (fee.enabled_query.value === "should_charge_gst") {
      return "Automatically Determined";
    }
    if (fee.operation_input.value === 0) {
      return "GST Exempt";
    }
    if (fee.apportion_from_source) {
      return "GST Inclusive";
    }
    return "GST Exclusive";
  }
  return "";
};
